import createIcon from '../../createIcon';

/**
 * @component @name FaceRetouchingNatural
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOC41IDE0Ljc1QzkuMTkwMzYgMTQuNzUgOS43NSAxNC4xOTA0IDkuNzUgMTMuNUM5Ljc1IDEyLjgwOTYgOS4xOTAzNiAxMi4yNSA4LjUgMTIuMjVDNy44MDk2NCAxMi4yNSA3LjI1IDEyLjgwOTYgNy4yNSAxMy41QzcuMjUgMTQuMTkwNCA3LjgwOTY0IDE0Ljc1IDguNSAxNC43NVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMC4yNyA5LjA4TDE5LjM1IDExLjA5QzE5LjQ0IDExLjU1IDE5LjUgMTIuMDIgMTkuNSAxMi41QzE5LjUgMTYuOTEgMTUuOTEgMjAuNSAxMS41IDIwLjVDNy4wOSAyMC41IDMuNSAxNi45MSAzLjUgMTIuNUMzLjUgMTIuNDUgMy41MSAxMi40IDMuNSAxMi4zNkM2LjEgMTEuMzggOC4xOSA5LjM3IDkuMjQgNi44MUMxMS4wOCA5LjA2IDEzLjg3IDEwLjUgMTcgMTAuNUMxNy40NSAxMC41IDE3Ljg5IDEwLjQ2IDE4LjMzIDEwLjRMMTcuNzMgOS4wOEwxNi44NSA3LjE1TDEyLjEzIDVMMTQuOTIgMy43M0wxNS42MyAzLjQxQzE0LjM3IDIuODMgMTIuOTcgMi41IDExLjUgMi41QzUuOTggMi41IDEuNSA2Ljk4IDEuNSAxMi41QzEuNSAxOC4wMiA1Ljk4IDIyLjUgMTEuNSAyMi41QzE3LjAyIDIyLjUgMjEuNSAxOC4wMiAyMS41IDEyLjVDMjEuNSAxMS4wMyAyMS4xNyA5LjYzIDIwLjYgOC4zN0wyMC4yNyA5LjA4WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE0LjUgMTQuNzVDMTUuMTkwNCAxNC43NSAxNS43NSAxNC4xOTA0IDE1Ljc1IDEzLjVDMTUuNzUgMTIuODA5NiAxNS4xOTA0IDEyLjI1IDE0LjUgMTIuMjVDMTMuODA5NiAxMi4yNSAxMy4yNSAxMi44MDk2IDEzLjI1IDEzLjVDMTMuMjUgMTQuMTkwNCAxMy44MDk2IDE0Ljc1IDE0LjUgMTQuNzVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjAuMSA2LjFMMTkgOC41TDE3LjkgNi4xTDE1LjUgNUwxNy45IDMuOUwxOSAxLjVMMjAuMSAzLjlMMjIuNSA1TDIwLjEgNi4xWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FaceRetouchingNatural = createIcon('FaceRetouchingNatural', [
  [
    'path',
    {
      d: 'M8.5 14.75C9.19036 14.75 9.75 14.1904 9.75 13.5C9.75 12.8096 9.19036 12.25 8.5 12.25C7.80964 12.25 7.25 12.8096 7.25 13.5C7.25 14.1904 7.80964 14.75 8.5 14.75Z',
      key: '1g5vdz',
    },
  ],
  [
    'path',
    {
      d: 'M20.27 9.08L19.35 11.09C19.44 11.55 19.5 12.02 19.5 12.5C19.5 16.91 15.91 20.5 11.5 20.5C7.09 20.5 3.5 16.91 3.5 12.5C3.5 12.45 3.51 12.4 3.5 12.36C6.1 11.38 8.19 9.37 9.24 6.81C11.08 9.06 13.87 10.5 17 10.5C17.45 10.5 17.89 10.46 18.33 10.4L17.73 9.08L16.85 7.15L12.13 5L14.92 3.73L15.63 3.41C14.37 2.83 12.97 2.5 11.5 2.5C5.98 2.5 1.5 6.98 1.5 12.5C1.5 18.02 5.98 22.5 11.5 22.5C17.02 22.5 21.5 18.02 21.5 12.5C21.5 11.03 21.17 9.63 20.6 8.37L20.27 9.08Z',
      key: '15l3ys',
    },
  ],
  [
    'path',
    {
      d: 'M14.5 14.75C15.1904 14.75 15.75 14.1904 15.75 13.5C15.75 12.8096 15.1904 12.25 14.5 12.25C13.8096 12.25 13.25 12.8096 13.25 13.5C13.25 14.1904 13.8096 14.75 14.5 14.75Z',
      key: '1mcq60',
    },
  ],
  [
    'path',
    {
      d: 'M20.1 6.1L19 8.5L17.9 6.1L15.5 5L17.9 3.9L19 1.5L20.1 3.9L22.5 5L20.1 6.1Z',
      key: 'v19zze',
    },
  ],
]);

export default FaceRetouchingNatural;
